<template>
  <section class="content">
    <box >
        <div slot="body">
            <form-wizard @on-complete="onComplete" shape="square" color="#20a0ff" error-color="#ff4949" title="Cadastro de Pacote de Viagem" subtitle="Avance pelas guias para finalizar o cadastro">
                
                <!-- Informações do Pacote -->
                <tab-content title="Informações do Pacote" icon="fa fa-suitcase" :before-change="validateFirstStep">
                <el-form :model="informacoesPacote" class="demo-form-inline" :rules="rules" ref="ruleForm">
                    <div class="row">
                        <div class="col-sm-4">
                            <el-form-item label="Título" class="form-item">
                                <input v-model="informacoesPacote.titulo" type="text" class="form-control" aria-describedby="sizing-addon1">
                            </el-form-item>
                        </div>
                    <!-- </div> -->
                    <!-- <div class="row"> -->
                        <div class="col-sm-8">
                            <el-form-item label="Descrição" class="form-item">
                                <textarea v-model="informacoesPacote.descricao" rows="1" cols="12" class="form-control"></textarea>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <el-form-item label="Quantidade de Passageiros" class="form-item">
                                <input v-model="informacoesPacote.quantidadePassageiros" class="form-control " type="number"/>
                            </el-form-item>
                        </div>
                        <div class="col-sm-4">
                            <el-form-item label="Preço" class="form-item">
                                <input v-model="informacoesPacote.preco" v-money="money" value="0" min="0" step="0.01" data-number-to-fixed="2" data-number-stepfactor="100" class="form-control currency"/>
                            </el-form-item>
                        </div>
                        <div class="col-sm-4">
                            <el-form-item label="Imagens" class="form-item">
                                <input type="file" id="file-input-pacote" class="form-control" multiple>
                            </el-form-item>        
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <el-form-item label="Tags do Pacote" prop="fullName" class="form-item">
                                <multi-select 
                                    :options="tagsParaPacote"
                                    :selected-options="informacoesPacote.tags"
                                    placeholder="Tags do Pacote"
                                    @select="onSelectPacote">
                                </multi-select>
                            </el-form-item>
                        </div>
                        <div class="col-sm-4">
                            <h4>Ativo</h4>
                            <toggle-button 
                                v-model="informacoesPacote.ativo"
                                :color="color" 
                                :sync="true" />
                        </div>
                    </div>
                </el-form>
                </tab-content>

                <!-- Informações do Hotel -->
                <tab-content title="Informações do Hotel" icon="fa fa-bed" :before-change="validateSecondStep">
                    <el-form :inline="true" :model="informacoesHotel" class="demo-form-inline" :rules="rulesLogin" ref="ruleFormLogin">
                        <div class="row">
                            <div class="col-sm-6">
                                <el-form-item label="Nome" class="form-item">
                                    <input v-model="informacoesHotel.nome" type="text" class="form-control" aria-describedby="sizing-addon1">
                                </el-form-item>
                            </div>
                        <!-- </div> -->
                        <!-- <div class="row"> -->
                            <div class="col-sm-6">
                                <el-form-item label="Endereço" class="form-item">
                                    <textarea v-model="informacoesHotel.endereco" rows="1" cols="12" class="form-control"></textarea>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <el-form-item label="Tags do Hotel" prop="fullName" class="form-item">
                                    <multi-select 
                                        :options="tagsParaHotel"
                                        :selected-options="informacoesHotel.tags"
                                        placeholder="Tags do Hotel"
                                        @select="onSelectHotel">
                                    </multi-select>
                                </el-form-item>
                            </div>
                            <div class="col-sm-6">
                                <el-form-item label="Imagens" class="form-item">
                                    <input type="file" id="file-input-hotel" class="form-control" multiple>
                                </el-form-item>        
                            </div>
                        </div>
                    </el-form>
                </tab-content>

                <!-- Informações Voo -->
                <tab-content title="Informações Voo" icon="fa fa-plane">
                    <el-form :inline="true" :model="informacoesVoo" class="demo-form-inline" :rules="rulesLogin" ref="ruleFormLogin">
                    <div v-for="(voo, index) in informacoesVoo" class="voosDiv">
                        <box>
                            <div slot="body">
                                <div class="row" >
                                <div class="col-sm-3">
                                    <el-form-item label="Companhia" class="form-item">
                                        <input v-model="voo.companhia" type="text" class="form-control" aria-describedby="sizing-addon1">
                                    </el-form-item>
                                </div>
                                <div class="col-sm-3">
                                    <el-form-item label="Tipo" class="form-item">
                                        <label class="radio-inline"><input type="radio" v-model="voo.tipo" value="ida" checked>Ida</label>
                                        <label class="radio-inline"><input type="radio" v-model="voo.tipo" value="volta">Volta</label>
                                    </el-form-item>
                                </div>
                                <div class="col-sm-3 adicionaVoo">
                                <a @click="removerVoo(index)"><i class="fa fa-times" aria-hidden="true"></i></a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <el-form-item label="Local Saída" class="form-item">
                                        <input v-model="voo.localSaida" type="text" class="form-control" aria-describedby="sizing-addon1">
                                    </el-form-item>
                                </div>
                                <div class="col-sm-3">
                                    <el-form-item label="Local Chegada" class="form-item">
                                        <input v-model="voo.localChegada" type="text" class="form-control" aria-describedby="sizing-addon1">
                                    </el-form-item>
                                </div>
                                <div class="col-sm-3">
                                    <el-form-item label="Hora de Saída" class="form-item">
                                        <input v-model="voo.horaSaida" type="datetime-local" class="form-control" aria-describedby="sizing-addon1">
                                    </el-form-item>
                                </div>
                                <div class="col-sm-3">
                                    <el-form-item label="Hora de Chegada" class="form-item">
                                        <input v-model="voo.horaChegada" type="datetime-local" class="form-control" aria-describedby="sizing-addon1">
                                    </el-form-item>
                                </div>
                            </div>
                            </div>
                        </box>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 adicionaVoo" style="text-align: center">
                            <a @click="adicionarVoo"><i class="fa fa-plus-circle" aria-hidden="true">Adicionar Voo</i></a>
                        </div>
                    </div>
                    </el-form>
                </tab-content>

                <el-button type="primary" class="btn btn-primary" slot="prev">Anterior</el-button>
                <el-button type="primary" class="btn btn-primary" slot="next">Próximo</el-button>
                <el-button v-show="!gravando" type="primary" class="btn btn-primary" slot="finish" >Confirmar</el-button>
                <el-button v-show="gravando" type="primary" class="btn btn-primary" slot="finish" disabled><i class="fa fa-spinner fa-spin"></i>Confirmar</el-button>
            </form-wizard>
        </div>
    </box>
  </section>
</template>
<script>
import axios from 'axios'
import Modal from '../Modal' // importando modal
import Box from '../Box'
import { MultiSelect } from 'vue-search-select'
import $ from 'jquery'
import {VMoney} from 'v-money'
import resource, { resourceServicos } from './resource'
import { setTimeout } from 'timers';
import s3 from '../../../services/s3'

export default {
  name: 'NovoPacote',
  directives: {money: VMoney},
  components: {
    'modal': Modal,
    'box': Box,
    MultiSelect
  },
  data() {
      return {
        items: [],
        lastSelectItem: {},
        money: {
            thousands: '.',
            decimal: ',',
            // prefix: 'R$ ',
            precision: 2,
        },
        tagsParaPacote:[],
        tagsParaHotel: [],
        gravando: false,
        mostrandoSenha: false,
        informacoesPacote: {
            titulo: '',
            descricao: '',
            preco: 0,
            quantidadePassageiros: 0,
            permiteCrianca: false,
            descontoCrianca: 0,
            tags: [],
            ativo: true
        },
        informacoesHotel: {
            nome: '',
            endereco: '',
            tags: []    
        },
        informacoesVoo: [{
            companhia: '',
            localSaida: '', 
            localChegada: '', 
            horaSaida: '', 
            horaChegada: '',
            tipo: 'ida' 
        }],
        imagensPacote: [],
        imagensHotel: [],
        empresa: window.localStorage.getItem('FB_ID'),
        alteracao: false,
        id_alteracao: null,
        // rules: {
        //     fullName: [{
        //       required: true,
        //       message: 'Por favor informe o nome completo',
        //       trigger: 'blur' // ou 'change'
        //     }],
        //     userName: [{
        //       required: true,
        //       message: 'Por favor Informe o nome de usuário',
        //       trigger: 'blur'
        //     }]
        //  },
        //  rulesLogin: {
        //     email: [{
        //         required: true,
        //         message: 'Por favor informe o email',
        //         trigger: 'blur'
        //     }],
        //     password: [{
        //         required: true,
        //         message: 'Por favor informe a senha',
        //         trigger: 'blur'
        //     }, {
        //         min: 6,
        //         max: 15,
        //         message: 'Senha deve ter entre 6 e 15 caracteres',
        //         trigger:'change'
        //     }],
        //     itens: [{
        //         required: true,
        //         message: 'Por favor informe as empresas que terá acesso',
        //         trigger: 'blur'
        //     }],
            
        //  }
        }
       },
        created() {
            this.getTagsPacote();
            this.getTagsHoteis();
            if(this.$route.params.id) {
                console.log('alterando');
                this.alteracao = true
                this.id_alteracao = this.$route.params.id
                this.getPacote(this.id_alteracao)
            }
        },
        methods: {
            getTagsPacote() {
                resource.getTagsPacote('pacote').then(res => {
                    this.tagsParaPacote = res.data.map((element,index) => ({ text: element.descricao, value: index, id: element.id }))
                }).catch(err => {
                    console.log('erro tagspacote => ', err)
                })
            },
            getTagsHoteis() {
                resource.getTagsPacote('hotel').then(res => {
                    this.tagsParaHotel = res.data.map((element,index) => ({ text: element.descricao, value: index, id: element.id }))
                }).catch(err => {
                    console.log('erro tagshoteis => ', err)
                })
            },
            getPacote(id) {
                resource.getPacote(id).then(res => {
                    console.log('res => ', res.data);
                    this.informacoesPacote = {
                        titulo: res.data.titulo,
                        descricao: res.data.descricao,
                        preco: res.data.preco.toFixed(2),
                        quantidadePassageiros: res.data.qtdepessoas,
                        permiteCrianca: res.data.permitecrianca,
                        descontoCrianca: res.data.descontocrianca,
                        tags: res.data.Tags.map((element, index) => ({ text: element.tag, value: index, id: element.id })),
                        ativo: res.data.ativo
                    };
                    this.informacoesHotel = {
                        nome: res.data.nomehotel,
                        endereco: res.data.enderecohotel,
                        tags: res.data.TagsHoteis.map((element, index) => ({ text: element.tag, value: index, id: element.id }))
                    }
                    this.informacoesVoo = res.data.InformacoesPassagens.map((element, index) => ({ 
                        companhia: element.companhia,
                        localSaida: element.localsaida, 
                        localChegada: element.localchegada, 
                        horaSaida: element.datahorasaida.substring(0,16), 
                        horaChegada: element.datahorachegada.substring(0,16),
                        tipo: element.tipo,
                        id: element.id
                    }));
                    this.imagensPacote = res.data.Imagens.map((element) => element.url);
                    this.imagensHotel = res.data.ImagensHotel.map((element) => element.url);
                })

            },
            adicionarVoo() {
                this.informacoesVoo.push({
                    companhia: '',
                    localSaida: '', 
                    localChegada: '', 
                    horaSaida: '', 
                    horaChegada: '',
                    tipo: 'ida' 
                })
            },
            removerVoo(index) {
                this.informacoesVoo.splice(index, 1)
            },
            onSelectPacote (itens, lastSelectItem) {
                this.informacoesPacote.tags = itens
                setTimeout(function(){ 
                    $('.delete').removeClass('detele').addClass('fa fa-trash');
                }, 100);
            },
            onSelectHotel(itens, lastSelectItem) {
                this.informacoesHotel.tags = itens
                setTimeout(function(){ 
                    $('.delete').removeClass('detele').addClass('fa fa-trash');
                }, 100);
            },
            // deselect option
            reset () {
                this.dadosLogin.itens = [] // reset
            },
            onComplete: function() {
                this.gravando = true
                this.gravarPacote()
            },
            gravarPacote () {
                this.gravando = true
                const filesPacote = document.getElementById('file-input-pacote').files;
                const filesHotel = document.getElementById('file-input-hotel').files;
                console.log(filesPacote)
                if(filesPacote && filesPacote.length > 0) {
                    for(let i = 0; i< filesPacote.length; i++) {
                        s3.getSignedRequest(filesPacote[i]).then(res => {
                            this.imagensPacote.push(res.url)
                        }).catch(err => {
                            this.gravando = false
                            alert('Erro ao salvar imagem');
                        })
                    };
                } else {
                    if(!this.alteracao) {
                        this.gravando = false
                        alert('É necessário selecionar uma imagem.');
                    }
                }

                if(filesHotel && filesHotel.length > 0) {
                    for(let i = 0; i< filesHotel.length; i++) {
                        s3.getSignedRequest(filesHotel[i]).then(res => {
                            this.imagensHotel.push(res.url)
                        }).catch(err => {
                            this.gravando = false
                            alert('Erro ao salvar imagem');
                        })
                    };
                } else {
                    if(!this.alteracao) {
                        this.gravando = false
                        alert('É necessário selecionar uma imagem.');
                    }
                }

                if(this.gravando) {
                    let temp = (filesPacote.length + filesHotel.length) * 1000;
                    setTimeout(() => {
                        if(this.gravando) {
                            this.finalizarGravacao();
                        }
                    }, temp)
                }
            },
            finalizarGravacao() {
                let objEnvio = {
                    pacote: this.informacoesPacote,
                    hotel: this.informacoesHotel,
                    voo: this.informacoesVoo
                };

                objEnvio.pacote.imagens = this.imagensPacote;
                objEnvio.hotel.imagens = this.imagensHotel;
                objEnvio.empresa = this.empresa;

                let preco = this.informacoesPacote.preco.replace('.', '');
                delete objEnvio.pacote.preco;
                preco = preco.replace(',', '.');

                objEnvio.pacote.preco = parseFloat(preco)

                console.log('gravar => ', JSON.stringify(objEnvio))
                if(this.alteracao) {
                    resource.atualizaPacote(objEnvio, this.id_alteracao).then(res => {
                        console.log('gravação concluida  => ', res)
                        this.$router.go(-1)
                    }).catch(err => {
                        console.log('erro na gravação  => ', err)
                        this.gravando = false;
                        this.$swal(
                            'Ops!',
                            'O Pacote não foi gravado.',
                            'error'
                        )
                    })
                } else {
                    resource.gravarPacote(objEnvio).then(res => {
                        console.log('gravação concluida  => ', res)
                        this.$router.go(-1)
                    }).catch(err => {
                        console.log('erro na gravação  => ', err)
                        this.gravando = false;
                        this.$swal(
                            'Ops!',
                            'O Pacote não foi gravado.',
                            'error'
                        )
                    })
                }
            },
            getSignedRequest(file){
                const xhr = new XMLHttpRequest();
                console.log(file.name)
                xhr.open('GET', this.$store.state.api+`s3/sign-s3?file-name=${file.name}&file-type=${file.type}`);
                xhr.onreadystatechange = () => {
                    if(xhr.readyState === 4){
                        if(xhr.status === 200){
                            const response = JSON.parse(xhr.responseText);
                            this.uploadFile(file, response.signedRequest, response.url);
                        }
                        else{
                            this.gravando = false
                            alert('Could not get signed URL.');
                        }
                    }
                };
                xhr.send();
            },
            uploadFile(file, signedRequest, url){
                const xhr = new XMLHttpRequest();
                xhr.open('PUT', signedRequest);
                xhr.onreadystatechange = () => {
                    if(xhr.readyState === 4){
                        if(xhr.status === 200){
                            this.informacoesPacote.img = url;
                            // console.log()
                        }
                        else{
                            alert('Por favor, selecione uma imagem.');
                            this.gravando = false
                        }
                    }
                };
                xhr.send(file);
            },
            validateFirstStep() {
                return new Promise((resolve, reject) => {
                    this.$refs.ruleForm.validate((valid) => {
                    resolve(valid);
                    document.addEventListener
                    });
                })
            },
            validateSecondStep() {
                return new Promise((resolve, reject) => {
                    this.$refs.ruleFormLogin.validate((valid) => {
                        //  if(this.dadosLogin.itens.length === 0) valid = false
                    resolve(valid);
                    });
                })

            },
       }
}
</script>
<style>
.el-form-item__error{
    color: red
}
.form-item{
        margin-bottom: 2%;
}
.voosDiv {
    /* border: 1px solid #21A0FF; */
    padding: 2em;
}
.adicionaVoo {
margin-top: 1.5%;
    cursor: pointer;
}  
</style>


// WEBPACK FOOTER //
// novoPacote.vue?22973538